/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { NavLink } from "react-router-dom";
import { Link } from "@mui/material";
import { ReactComponent as ClarityLogo } from "cms/assets/images/claritybc-logo-white.svg";
import { ReactComponent as EmailIcon } from "cms/assets/icons/envelope.svg";
import { ReactComponent as LinkedInIcon } from "cms/assets/icons/linkedin.svg";

const Footer = () => {
    return (
        <>
            <div id="footer" className="page-footer">
                <div className="page-footer-content">
                    <div className='footer-logo'>
                        <ClarityLogo />
                    </div>
                    <div className='footer-contact-buttons'>
                        <Link
                            href='mailto:claritybc@simplicitycms.ca?subject=Question about the ClarityBC Project'
                            rel='noopener noreferrer'
                        >
                            <EmailIcon />
                            Questions? Email Us
                        </Link>
                        <Link
                            className='linkedin-button'
                            href='https://www.linkedin.com/company/simplicitycms'
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            <LinkedInIcon />
                            Follow SimpliCity for ClarityBC Updates
                        </Link>
                    </div>
                </div>
            </div>
            <div className="page-copyright">
                <div className="page-copyright-content">
                    <p>
                        &copy;{" "}{new Date().getFullYear()}{" "}
                        <NavLink
                            aria-label="Privacy Policy"
                            rel="noopener noreferrer"
                            target="_blank"
                            to="https://www.radical.io/"
                        >
                            Radical I/O Technology Inc.
                        </NavLink>
                        {" "}All rights reserved
                    </p>
                    <ul>
                        <li>
                            <div>
                                <NavLink
                                    aria-label="Privacy Policy"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    to="https://www.simplicitycms.ca/"
                                >
                                    Built with SimpliCity
                                </NavLink>&trade;
                            </div>
                        </li>
                        <li>
                            <div>
                                <NavLink
                                    aria-label="Privacy Policy"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    to="https://www.simplicitycms.ca/privacy"
                                >
                                    Privacy Policy
                                </NavLink>
                            </div>
                        </li>
                        <li>
                            <div>
                                <NavLink
                                    aria-label="Terms of Service"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    to="https://www.simplicitycms.ca/terms"
                                >
                                    Terms of Service
                                </NavLink>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export { Footer };
